const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page006_game1/audio/8_blue.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game1/img/audioOn.png', iconOff: 'games/page006_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page006_game1/audio/9_red.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game1/img/audioOn.png', iconOff: 'games/page006_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page006_game1/audio/10_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game1/img/audioOn.png', iconOff: 'games/page006_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page006_game1/audio/11_green.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game1/img/audioOn.png', iconOff: 'games/page006_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page006_game1/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#a6abae',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 5 },
    { connectId: 2, connectedWith: 8 },
    { connectId: 3, connectedWith: 6 },
    { connectId: 4, connectedWith: 7 },
  ],

  autoCheck: true,
  numberOfGoodLines: 4,
  sounds: [
    { src: 'games/page006_game1/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page006_game1/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page006_game1/audio/8_blue.mp3', id: 'blue' },
    { src: 'games/page006_game1/audio/11_green.mp3', id: 'green' },
    { src: 'games/page006_game1/audio/9_red.mp3', id: 'red' },
    { src: 'games/page006_game1/audio/10_yellow.mp3', id: 'yellow' },
  ],
  groups: [
    {
      name: 'left',
      items: [
        {
          audio: 'a01',
          audioId: 'blue',
          connectId: 1,
          image: { src: 'games/page006_game1/img/tubka_b.png' },
          imageStyle: { position: 'absolute', width: '268px', height: '194px' },
          pos: {
            x: 1515,
            y: 163,
            width: 268,
            height: 194,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 1, y: 167 }],
        },
        {
          audio: 'a04',
          audioId: 'green',
          connectId: 2,
          image: { src: 'games/page006_game1/img/tubka_g.png' },
          imageStyle: { position: 'absolute', width: '268px', height: '194px' },
          pos: {
            x: 1515,
            y: 348,
            width: 268,
            height: 194,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 1, y: 167 }],
        },
        {
          audio: 'a02',
          audioId: 'red',
          connectId: 3,
          image: { src: 'games/page006_game1/img/tubka_r.png' },
          imageStyle: { position: 'absolute', width: '268px', height: '194px' },
          pos: {
            x: 1515,
            y: 534,
            width: 268,
            height: 194,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 1, y: 167 }],
        },
        {
          audio: 'a03',
          audioId: 'yellow',
          connectId: 4,
          image: { src: 'games/page006_game1/img/tubka_y.png' },
          imageStyle: { position: 'absolute', width: '268px', height: '194px' },
          pos: {
            x: 1515,
            y: 719,
            width: 268,
            height: 194,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 1, y: 167 }],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          connectId: 5,
          image: { src: 'games/page006_game1/img/1.png' },
          imageStyle: { position: 'absolute', width: '110px', height: '100px' },
          pos: {
            x: 646,
            y: 828,
            width: 110,
            height: 100,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 110, y: 50 }],
        },
        {
          connectId: 6,
          image: { src: 'games/page006_game1/img/2.png' },
          imageStyle: { position: 'absolute', width: '102px', height: '95px' },
          pos: {
            x: 447,
            y: 853,
            width: 102,
            height: 95,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 106, y: 39 }],
        },
        {
          connectId: 7,
          image: { src: 'games/page006_game1/img/3.png' },
          imageStyle: { position: 'absolute', width: '140px', height: '85px' },
          pos: {
            x: 543,
            y: 902,
            width: 140,
            height: 85,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 143, y: 23 }],
        },
        {
          connectId: 8,
          image: { src: 'games/page006_game1/img/4.png' },
          imageStyle: { position: 'absolute', width: '128px', height: '74px' },
          pos: {
            x: 560,
            y: 774,
            width: 128,
            height: 74,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 128, y: 31 }],
        },
      ],
    },
  ],
};
export default config;
